import React from 'react';

import Card from './card';
import '../styles/skills.css';

import Icon from '../assets/icons/react-brands.svg';

const Skills = () => {

    return (
        <div className="card-container">
            <Card
                title={{ icon: Icon, text: 'React JS' }}
                content={{
                    section1: {
                        title: null,
                        list: `I enjoy the concept of reusable components and React Hooks.
                        React Hooks has been a bread and butter for me.`
                    },
                    section2: {
                        title: 'Technologies that i used :',
                        list: 'Yarn, NextJS, Redux, Xstate',
                    },
                }}
            />

            <Card
                disabled={true}
            />

            <Card
                disabled={true}
            />
        </div>
    )
}

export default Skills;
